(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tab-product-list"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tab-product-list')) {
    customElements.define('tab-product-list', class extends HTMLElement {
      constructor() {
        super();
        this.syncTabs = this.syncTabs.bind(this);
        this.onSectionLoad = (event) => {
          if (event.target.contains(this)) this.syncTabs();
        };
      }

      connectedCallback() {
        this.menu = this.closest('[data-tab-menu]');
        this.frame = requestAnimationFrame(this.syncTabs);
        document.addEventListener('DOMContentLoaded', this.syncTabs);
        window.addEventListener('load', this.syncTabs);
        document.addEventListener('shopify:section:load', this.onSectionLoad);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        document.removeEventListener('DOMContentLoaded', this.syncTabs);
        window.removeEventListener('load', this.syncTabs);
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
        // The shared tab head lives outside this element. Return its buttons so
        // a removed/reordered instance cannot leave orphan buttons in that head.
        this.menu?.querySelectorAll('[data-tab-owner]').forEach((button) => {
          if (button.dataset.tabOwner === this.id && !this.contains(button)) {
            this.append(button);
          }
        });
      }

      syncTabs() {
        if (!this.isConnected || !this.menu || typeof syncTabButtonHeads !== 'function') return;
        // A section refresh may retain the active ID but replace its DOM nodes.
        // Force the existing tab controller to apply state to the new nodes.
        delete this.menu.dataset.tabReady;
        delete this.menu.dataset.activeTabId;
        syncTabButtonHeads(this.menu);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-list"] && !Shopify.designMode) return;
  try {
    // localStorage cache (6h TTL) for the Searchanise product list and for per-product
  // ratings, so repeat visits don't re-fetch them. Storage may be unavailable
  // (private mode, quota) - every access is wrapped and simply falls back to fetching.
  const SEARCHANISE_CACHE_TTL = 6 * 60 * 60 * 1000;
  const SEARCHANISE_ITEMS_CACHE_PREFIX = 'searchanise-items:';
  const SEARCHANISE_RATINGS_CACHE_KEY = 'searchanise-ratings';

  function searchaniseReadCache(key) {
    try {
      const cached = JSON.parse(localStorage.getItem(key));
      if (cached && Date.now() - cached.time < SEARCHANISE_CACHE_TTL) return cached.data;
    } catch (error) {}
    return null;
  }

  function searchaniseWriteCache(key, data) {
    try {
      localStorage.setItem(key, JSON.stringify({ time: Date.now(), data }));
    } catch (error) {}
  }

  function searchaniseReadRatingsCache() {
    try {
      const cached = JSON.parse(localStorage.getItem(SEARCHANISE_RATINGS_CACHE_KEY)) || {};
      const fresh = {};
      Object.keys(cached).forEach((productId) => {
        if (Date.now() - cached[productId].time < SEARCHANISE_CACHE_TTL) fresh[productId] = cached[productId];
      });
      return fresh;
    } catch (error) {
      return {};
    }
  }

  // Extracts the product handle from a Searchanise item's storefront link
  // (e.g. "https://shop.myshopify.com/products/some-handle" or "/products/some-handle"),
  // needed to look the product back up via `all_products[handle]` on the server.
  function searchaniseGetHandleFromLink(link) {
    try {
      const path = /^https?:\/\//i.test(link) ? new URL(link).pathname : String(link).split('?')[0];
      const segments = path.split('/').filter(Boolean);
      return segments[segments.length - 1] || '';
    } catch (error) {
      return '';
    }
  }

  // The stars widget already holds pre-rendered badge HTML from
  // `product.metafields.judgeme.badge` (the ORIGINAL fallback product's rating).
  // Refresh ratings for a whole list of products with ONE request instead of one
  // request per product: sections/searchanise-ratings.liquid renders each product's
  // real judgeme.badge metafield, fetched via the Section Rendering API on the
  // /search route (the one route where Liquid can read back an arbitrary query
  // string, via `search.terms`).
  //
  // Liquid has no lookup-by-id for products (only `all_products[handle]`), so each
  // entry is sent as "<productId>:<handle>" - the handle resolves the real product
  // server-side, and the id is echoed back as `data-id` so the response can be
  // matched directly against Searchanise's `item.product_id`.
  async function searchaniseFetchRatings(entries) {
    if (!entries.length) return {};
    try {
      const query = entries.map(({ productId, handle }) => `${productId}:${handle}`).join(',');
      const url = `/search?section_id=searchanise-ratings&type=product&q=${encodeURIComponent(query)}`;
      const res = await fetch(url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ratings = {};
      doc.querySelectorAll('[data-id]').forEach((node) => {
        ratings[node.getAttribute('data-id')] = node.innerHTML;
      });
      return ratings;
    } catch (error) {
      console.error('Searchanise ratings fetch error:', error);
      return {};
    }
  }

  // Searchanise indexes each variant's price per market as `price_<COUNTRY>_<CURRENCY>`
  // (e.g. `price_GB_GBP`). Sending that field as `union[price][min]` (plus
  // `shopify_country` / `shopify_currency`) for the visitor's current market makes the
  // item's own `price` the lowest variant price in that market, and price sorting
  // follows it too.
  function searchaniseGetMarket() {
    const shopify = window.Shopify || {};
    const country = shopify.country;
    const currency = shopify.currency && shopify.currency.active;
    if (!country || !currency) return null;
    const priceField = `price_${country}_${currency}`;
    return {
      currency,
      priceField,
      params: `&union%5Bprice%5D%5Bmin%5D=${encodeURIComponent(priceField)}&shopify_currency=${encodeURIComponent(currency)}&shopify_country=${encodeURIComponent(country)}`
    };
  }

  // The price always comes from `item.price`. When the market has no price indexed in
  // Searchanise, `item.price` stays the base price, so it is labelled with the shop currency.
  function searchaniseGetPrice(item, market, baseCurrency) {
    const localized = market && (item.shopify_variants || []).some((variant) => Number(variant[market.priceField]) > 0);
    return { amount: Number(item.price) || 0, currency: localized ? market.currency : baseCurrency };
  }

  function searchaniseFormatPrice(amount, currency) {
    try {
      const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      }).format(amount);
      return `${formatted} ${currency}`;
    } catch (error) {
      return `${amount} ${currency}`;
    }
  }

  // The real static-product-card blocks are already rendered by Liquid against the
  // collection's real products (identical markup/classes/settings as collection mode).
  // We only swap image / product type / price text in place on those existing nodes -
  // no markup is rebuilt in JS, so styling always matches whatever the merchant configured.
  function searchaniseApplyItem(card, item) {
    const title = String(item.name || item.title || '');

    card.href = item.link;
    card.setAttribute('aria-label', title);

    const image = card.querySelector('[data-role="product-image"] img');
    if (image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = item.image_link;
      image.alt = title;
    }

    const type = card.querySelector('[data-role="product-type"]');
    if (type) type.textContent = item.product_type || '';

    const price = card.querySelector('[data-role="product-price"]');
    if (price && item.price_currency) price.textContent = searchaniseFormatPrice(item.price_amount, item.price_currency);

    return image;
  }

  // Resolves once the swapped-in image has loaded (or failed / timed out), so the loading
  // skeleton isn't removed while the old image is still showing. Images outside the
  // viewport (lazy-loaded, off-screen carousel slides) aren't waited for.
  function searchaniseWaitForImage(image) {
    return new Promise((resolve) => {
      if (!image || image.complete) return resolve();
      const rect = image.getBoundingClientRect();
      const inViewport = rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
      if (!inViewport) return resolve();
      const done = () => {
        image.removeEventListener('load', done);
        image.removeEventListener('error', done);
        resolve();
      };
      image.addEventListener('load', done);
      image.addEventListener('error', done);
      setTimeout(done, 3000);
    });
  }

  // Ratings come from the real Shopify product (Searchanise doesn't have them).
  async function searchaniseApplyRatings(cards, items) {
    const targets = [];
    items.forEach((item, index) => {
      const card = cards[index];
      if (!card || !item.product_id) return;
      const handle = searchaniseGetHandleFromLink(item.link);
      const stars = card.querySelector('[data-role="product-stars"]');
      if (!handle || !stars) return;
      targets.push({ stars, productId: String(item.product_id), handle });
    });

    // Only request what is actually displayed: no stars widget on the cards -> no request.
    const seen = new Set();
    const entries = [];
    targets.forEach(({ productId, handle }) => {
      if (seen.has(productId)) return;
      seen.add(productId);
      entries.push({ productId, handle });
    });
    if (!entries.length) return;

    const cachedRatings = searchaniseReadRatingsCache();
    const fetchedRatings = await searchaniseFetchRatings(entries.filter(({ productId }) => !cachedRatings[productId]));
    const ratings = {};
    Object.keys(cachedRatings).forEach((productId) => {
      ratings[productId] = cachedRatings[productId].badge;
    });
    Object.keys(fetchedRatings).forEach((productId) => {
      ratings[productId] = fetchedRatings[productId];
      cachedRatings[productId] = { time: Date.now(), badge: fetchedRatings[productId] };
    });
    if (Object.keys(fetchedRatings).length) {
      try {
        localStorage.setItem(SEARCHANISE_RATINGS_CACHE_KEY, JSON.stringify(cachedRatings));
      } catch (error) {}
    }

    targets.forEach(({ stars, productId }) => {
      if (ratings[productId]) {
        stars.dataset.id = productId;
        stars.innerHTML = ratings[productId];
      }
    });
  }

  async function searchaniseLoadProductList(el) {
    const apiKey = el.dataset.apiKey;
    const collection = el.dataset.collection;
    const quantity = parseInt(el.dataset.quantity, 10) || 8;
    if (!apiKey || !collection) {
      el.classList.remove('is-searchanise-loading');
      return;
    }

    const cards = Array.from(el.querySelectorAll('[data-role="product-card"]'));
    if (!cards.length) {
      el.classList.remove('is-searchanise-loading');
      return;
    }

    // The `is-searchanise-loading` class is already present from the server-rendered
    // HTML (see product-list.liquid), so the pulse starts from first paint with no
    // flash of "normal-looking" fallback data before JS has a chance to run.
    try {
      const sortBy = el.dataset.sortBy || 'sales_amount';
      const sortOrder = el.dataset.sortOrder || '';
      const sortParams = sortOrder
        ? `&sortBy=${encodeURIComponent(sortBy)}&sortOrder=${encodeURIComponent(sortOrder)}`
        : `&sortBy=${encodeURIComponent(sortBy)}`;
      const market = searchaniseGetMarket();
      const url = `https://searchserverapi.com/getresults?api_key=${encodeURIComponent(apiKey)}&items=true&output=json&collection=${encodeURIComponent(collection)}&maxResults=${quantity}&startIndex=0${sortParams}${market ? market.params : ''}`;
      const baseCurrency = el.dataset.baseCurrency;
      const cacheKey = `${SEARCHANISE_ITEMS_CACHE_PREFIX}${url}`;
      let items = searchaniseReadCache(cacheKey);
      if (!items) {
        const res = await fetch(url);
        const data = await res.json();
        items = (data.items || []).slice(0, quantity).map((item) => {
          const price = searchaniseGetPrice(item, market, baseCurrency);
          return {
            product_id: item.product_id,
            name: item.name,
            title: item.title,
            link: item.link,
            image_link: item.image_link,
            product_type: item.product_type,
            price_amount: price.amount,
            price_currency: price.currency
          };
        });
        if (items.length) searchaniseWriteCache(cacheKey, items);
      }
      if (!items.length) return;

      // Fewer Searchanise results than rendered cards: leave the extra cards showing
      // their real fallback product rather than guessing/hiding anything.
      const images = [];
      items.forEach((item, index) => {
        if (cards[index]) images.push(searchaniseApplyItem(cards[index], item));
      });
      await Promise.all([
        searchaniseApplyRatings(cards, items),
        ...images.map(searchaniseWaitForImage)
      ]);
    } catch (error) {
      console.error('Searchanise product list error:', error);
    } finally {
      setTimeout(() => {
        el.classList.remove('is-searchanise-loading');
      }, 200);
    }
  }

  function initSearchaniseProductLists(root) {
    (root || document).querySelectorAll('[data-searchanise]:not([data-searchanise-ready])').forEach((el) => {
      el.dataset.searchaniseReady = 'true';
      searchaniseLoadProductList(el);
    });
  }

  initSearchaniseProductLists();
  document.addEventListener('DOMContentLoaded', () => initSearchaniseProductLists());
  document.addEventListener('shopify:section:load', (event) => initSearchaniseProductLists(event.target));
  } catch(e) { console.error(e); }
})();

})();
